// ── BeBodywise · Sistema de cuentas (lado cliente / localStorage) ──
// NOTA: Esto guarda las cuentas en el navegador del cliente (localStorage).
// Funciona de verdad en este dispositivo: registro, login, sesión y descuento.
// Para una tienda en producción (cuentas entre dispositivos y contraseñas
// realmente seguras) se debe migrar a un backend con base de datos.
(function () {
  const USERS_KEY = 'bbw_users';
  const SESSION_KEY = 'bbw_session';
  const PROMO_FLAG = 'bbw_promo_seen';
  const MEMBER_DISCOUNT = 0.10;

  // ---- almacenamiento ----
  function getUsers() { return JSON.parse(localStorage.getItem(USERS_KEY) || '{}'); }
  function saveUsers(u) { localStorage.setItem(USERS_KEY, JSON.stringify(u)); }
  function hash(str) {
    let h = 5381;
    for (let i = 0; i < str.length; i++) { h = ((h << 5) + h) + str.charCodeAt(i); h = h & 0xffffffff; }
    return String(h >>> 0);
  }

  function getSession() { return JSON.parse(localStorage.getItem(SESSION_KEY) || 'null'); }
  function isLoggedIn() { return !!getSession(); }
  function getDiscount() { return isLoggedIn() ? MEMBER_DISCOUNT : 0; }

  function setSession(s) {
    localStorage.setItem(SESSION_KEY, JSON.stringify(s));
    renderAccount();
    document.dispatchEvent(new Event('bbw-auth-change'));
  }
  function logout() {
    localStorage.removeItem(SESSION_KEY);
    renderAccount();
    document.dispatchEvent(new Event('bbw-auth-change'));
  }

  function register(name, email, password) {
    email = (email || '').trim().toLowerCase();
    if (!name || !email || !password) return { ok: false, error: 'Completa todos los campos.' };
    const users = getUsers();
    if (users[email]) return { ok: false, error: 'Ya existe una cuenta con este correo. Inicia sesión.' };
    users[email] = { name: name.trim(), email, pass: hash(password) };
    saveUsers(users);
    setSession({ name: name.trim(), email });
    return { ok: true };
  }

  function login(email, password) {
    email = (email || '').trim().toLowerCase();
    const users = getUsers();
    const u = users[email];
    if (!u || u.pass !== hash(password)) return { ok: false, error: 'Correo o contraseña incorrectos.' };
    setSession({ name: u.name, email });
    return { ok: true };
  }

  // ---- UI: inyección de modal + popup ----
  function injectUI() {
    const modal = document.createElement('div');
    modal.className = 'auth-overlay';
    modal.id = 'authOverlay';
    modal.innerHTML = `
      <div class="auth-box">
        <button class="auth-x" id="authClose" aria-label="Cerrar">&times;</button>
        <div class="auth-tabs">
          <button class="auth-tab active" data-tab="login">Iniciar sesión</button>
          <button class="auth-tab" data-tab="register">Crear cuenta</button>
        </div>
        <div class="auth-perk">Obtén un <strong>10% de descuento</strong> al crear tu cuenta</div>
        <form class="auth-form" data-form="login">
          <input type="email" name="email" placeholder="Correo electrónico" required />
          <input type="password" name="password" placeholder="Contraseña" required />
          <div class="auth-error" data-err></div>
          <button type="submit" class="btn-primary">Iniciar sesión</button>
        </form>
        <form class="auth-form" data-form="register" style="display:none">
          <input type="text" name="name" placeholder="Nombre" required />
          <input type="email" name="email" placeholder="Correo electrónico" required />
          <input type="password" name="password" placeholder="Contraseña (mín. 6 caracteres)" required minlength="6" />
          <div class="auth-error" data-err></div>
          <button type="submit" class="btn-primary">Crear cuenta y obtener 10%</button>
        </form>
        <button class="auth-guest" id="authGuest">Continuar como invitado</button>
      </div>`;
    document.body.appendChild(modal);

    const popup = document.createElement('div');
    popup.className = 'promo-overlay';
    popup.id = 'promoPopup';
    popup.innerHTML = `
      <div class="promo-box">
        <button class="promo-close" id="promoClose" aria-label="Cerrar">&times;</button>
        <div class="promo-badge">10%</div>
        <div class="promo-text">
          <strong>Inicia sesión y ahorra 10%</strong>
          <span>Crea tu cuenta gratis y obtén un 10% de descuento en tu pedido.</span>
        </div>
        <div class="promo-actions">
          <button class="btn-primary promo-cta" id="promoLogin">Obtener mi 10%</button>
          <button class="promo-guest" id="promoGuest">Seguir como invitado</button>
        </div>
      </div>`;
    document.body.appendChild(popup);

    wireUI();
  }

  function wireUI() {
    const overlay = document.getElementById('authOverlay');
    document.getElementById('authClose').onclick = closeLogin;
    overlay.addEventListener('click', e => { if (e.target === overlay) closeLogin(); });
    document.getElementById('authGuest').onclick = () => { markPromoSeen(); closeLogin(); };

    overlay.querySelectorAll('.auth-tab').forEach(tab => {
      tab.onclick = () => switchTab(tab.dataset.tab);
    });

    overlay.querySelector('[data-form="login"]').addEventListener('submit', e => {
      e.preventDefault();
      const f = e.target;
      const res = login(f.email.value, f.password.value);
      handleAuthResult(res, f);
    });
    overlay.querySelector('[data-form="register"]').addEventListener('submit', e => {
      e.preventDefault();
      const f = e.target;
      const res = register(f.name.value, f.email.value, f.password.value);
      handleAuthResult(res, f);
    });

    // Popup
    const promo = document.getElementById('promoPopup');
    document.getElementById('promoClose').onclick = () => { markPromoSeen(); hidePromo(); };
    document.getElementById('promoGuest').onclick = () => { markPromoSeen(); hidePromo(); };
    document.getElementById('promoLogin').onclick = () => { hidePromo(); switchTab('register'); openLogin(); };
    promo.addEventListener('click', e => { if (e.target === promo) { markPromoSeen(); hidePromo(); } });
  }

  function switchTab(tab) {
    const overlay = document.getElementById('authOverlay');
    overlay.querySelectorAll('.auth-tab').forEach(t => t.classList.toggle('active', t.dataset.tab === tab));
    overlay.querySelectorAll('.auth-form').forEach(f => f.style.display = f.dataset.form === tab ? '' : 'none');
    overlay.querySelectorAll('[data-err]').forEach(e => e.textContent = '');
  }

  function handleAuthResult(res, form) {
    const err = form.querySelector('[data-err]');
    if (!res.ok) { err.textContent = res.error; return; }
    err.textContent = '';
    form.reset();
    closeLogin();
    markPromoSeen();
    showWelcomeToast();
  }

  function openLogin() {
    closeDrawerIfOpen();
    document.getElementById('authOverlay').classList.add('show');
  }
  function closeLogin() { document.getElementById('authOverlay').classList.remove('show'); }

  function closeDrawerIfOpen() {
    if (typeof window.closeMenu === 'function') window.closeMenu();
  }

  // ---- Popup promocional a los 5s ----
  function markPromoSeen() { sessionStorage.setItem(PROMO_FLAG, '1'); }
  function hidePromo() { const p = document.getElementById('promoPopup'); if (p) p.classList.remove('show'); }
  function maybeShowPromo() {
    if (isLoggedIn()) return;
    if (sessionStorage.getItem(PROMO_FLAG)) return;
    setTimeout(() => {
      if (isLoggedIn() || sessionStorage.getItem(PROMO_FLAG)) return;
      const p = document.getElementById('promoPopup');
      if (p) p.classList.add('show');
    }, 5000);
  }

  function showWelcomeToast() {
    let t = document.getElementById('authToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'authToast';
      t.className = 'auth-toast';
      document.body.appendChild(t);
    }
    const s = getSession();
    t.innerHTML = `<strong>¡Hola ${s ? s.name : ''}!</strong> Tu 10% de descuento está activo en el carrito.`;
    t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), 4500);
  }

  // ---- Estado de cuenta en el menú/nav ----
  function renderAccount() {
    const slots = document.querySelectorAll('[data-account]');
    const s = getSession();
    slots.forEach(slot => {
      if (s) {
        slot.innerHTML = `
          <div class="acct-info">
            <span class="acct-hi">Hola, <strong>${s.name}</strong></span>
            <span class="acct-badge">10% activo</span>
          </div>
          <button class="acct-logout" onclick="bbwAuth.logout()">Cerrar sesión</button>`;
      } else {
        slot.innerHTML = `
          <button class="acct-login-btn" onclick="bbwAuth.openLogin()">Iniciar sesión</button>
          <span class="acct-hint">y obtén 10% de descuento</span>`;
      }
    });
  }

  // ---- API pública ----
  window.bbwAuth = {
    login, register, logout, getSession, isLoggedIn, getDiscount, openLogin,
    MEMBER_DISCOUNT
  };

  // ---- init ----
  function init() {
    injectUI();
    renderAccount();
    maybeShowPromo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
